import { render, staticRenderFns } from "./NewCartedProduct.vue?vue&type=template&id=d623310e&"
import script from "./NewCartedProduct.vue?vue&type=script&lang=js&"
export * from "./NewCartedProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports